/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  editReimbursementAccount,
  resetEditReimbursementAccount,
  viewAccountDetailR,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import {
  panLookUp,
  resetPanLookup,
  resetPANVerification,
  verifyPAN,
} from "../../../../../redux/features/sharedResources/sharedResources";
import ReimbursementPanDetails from "../ReimbursementPanDetails";

const ReimbursementEditPan = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [showAction, setShowAction] = useState(false);
  const [test, setTest] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [alreadyLinked, setAlreadyLinked] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [accountType, setAccountType] = useState({ type: "", id: "" });
  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [shutViewAll, setShutViewAll] = useState(false);
  const [isAchived, setIsArchived] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isDennied, setIsDennied] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [hideCreate, setHideCreate] = useState(false);
  const [previousBankNo, setPreviousBankNo] = useState("");
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [cancelBut, setCanclebtn] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    newGstValue: "",
  });
  const [updateActive, setUpdateActive] = useState(false);
  const [updatedGst, setUpdatedGst] = useState({
    id: "",
    panNo: "",
    gstNo: "",
  });
  const [associatedPan, setAssociatedPan] = useState(true);
  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Reimbursement account",
  );

  const [GSTPanExist, setGSTPanExist] = useState(false);
  const [openPopEditCheck, setOpenPopEditCheck] = useState(false);

  const [handleUpdateNext, setHandleUpdateNext] = useState(false);
  const [isBankLinkedToThisPan, setIsBankLinkedToThisPan] = useState(null);

  const verifyDebounceRef = useRef(null);
  const retryCountRef = useRef(GlobalConfiguration.lengthCheckZero);
  const pendingVerifyPanRef = useRef(null);
  const abortControllerRef = useRef(null);
  const lastLookupRef = useRef({ pan: null, page: null });
  const cachedLookupPanRef = useRef(null);
  const cachedLookupAccountsRef = useRef([]);
  const VERIFY_DEBOUNCE_MS = IntervalConfiguration.intervalTiny;

  const syncLookupCache = (pan, accounts) => {
    if (pan && accounts?.length) {
      cachedLookupPanRef.current = pan;
      cachedLookupAccountsRef.current = accounts;
    }
  };

  const getLookupAccountsForCurrentPan = () => {
    const pan = payload.panNumber;
    if (pan?.length !== GlobalConfiguration.panLength) {
      return [];
    }
    if (allData?.length > GlobalConfiguration.lengthCheckZero) {
      return allData;
    }
    if (
      panLookupData?.status &&
      cachedLookupPanRef.current === pan &&
      cachedLookupAccountsRef.current.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      return cachedLookupAccountsRef.current;
    }
    if (
      panLookupData?.status &&
      lastLookupRef.current.pan === pan &&
      panLookupData?.beneficiary_accounts?.length
    ) {
      return panLookupData.beneficiary_accounts;
    }
    return [];
  };

  const {
    panVerificationData,
    panLookupData,
    panLookupLoading,
    panVerificationLoading,
    panLookupError,
  } = useSelector((state) => state.sharedResources);

  const {
    reimbursementAccountEditData,
    reimbursementAccountEditError,
    viewAccountDetailData,
    viewAccountDetailLoading,
  } = useSelector((state) => state.ReimburseAccount);

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(1);

  const reimbursementAcccount =
    viewAccountDetailData?.reimbursement_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ];
  const currentBankAccNo = reimbursementAcccount?.bank_acc_no;

  const haveLinkNew = allData?.some((val) => {
    return val?.bank_acc_no === currentBankAccNo && val?.id !== id;
  });

  const dispatchLookupIfNeeded = (
    pan,
    pageNo = GlobalConfiguration.lengthCheckOne,
  ) => {
    if (!pan || alreadyLinked) return;
    if (
      lastLookupRef.current.pan === pan &&
      lastLookupRef.current.page === pageNo
    ) {
      return;
    }
    lastLookupRef.current = { pan, page: pageNo };
    dispatch(panLookUp({ pan_number: pan, page: pageNo }));
  };

  const getVerifiedPanFromResponse = () => {
    const panFromResponse =
      panVerificationData?.pan_details?.pan_number ||
      panVerificationData?.pan_details?.pan;
    return panFromResponse ? String(panFromResponse).toUpperCase() : "";
  };

  useEffect(() => {
    if (!panVerificationLoading) {
      if (
        pendingVerifyPanRef.current != null &&
        payload.panNumber !== pendingVerifyPanRef.current
      ) {
        return;
      }
      const isCurrentPanFullLength =
        payload.panNumber?.length === GlobalConfiguration.panLength;
      const responsePan = getVerifiedPanFromResponse();
      if (responsePan && responsePan !== payload.panNumber?.toUpperCase()) {
        return;
      }
      if (panVerificationData?.status === true) {
        if (isCurrentPanFullLength) {
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;
          setVerifiedPan(true);

          if (services?.includes("RUAccount") || services?.includes("Admin")) {
            dispatchLookupIfNeeded(payload.panNumber, 1);
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "RUAccount" },
            });
          }

          setPayload({
            ...payload,
            legalName: panVerificationData?.pan_details?.full_name,
          });
        }
      } else if (panVerificationData?.status === false) {
        if (isCurrentPanFullLength) {
          setVerifiedPan(false);
          setPayload({
            ...payload,
            gstin: "",
          });
        }
      }
    }
  }, [panVerificationData, payload.panNumber, services, navigate, dispatch]);

  useEffect(() => {
    // let gstStoredData = sessionStorage.getItem("PAN GST Edit NewValue");
    const lookupPan = lastLookupRef.current.pan;
    const isLookupForCurrentPan =
      lookupPan === payload.panNumber &&
      payload.panNumber?.length === GlobalConfiguration.panLength;

    if (!panLookupLoading && panLookupData?.status && isLookupForCurrentPan) {
      if (allData?.length === GlobalConfiguration.lengthCheckZero) {
        const accounts = panLookupData?.beneficiary_accounts ?? [];
        syncLookupCache(payload.panNumber, accounts);
        setAllData((allData) => [...allData, ...accounts]);

        const totalRecords =
          panLookupData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
        const firstPageLength =
          panLookupData?.beneficiary_accounts?.length ??
          GlobalConfiguration.lengthCheckZero;
        if (
          totalRecords > firstPageLength &&
          (services?.includes("RUAccount") || services?.includes("Admin"))
        ) {
          setPage(2);
          dispatchLookupIfNeeded(payload.panNumber, 2);
        }

        if (panLookupData?.title?.records > allData?.length) {
          setTest(false);
        } else {
          setTest(true);
        }
      } else if (panLookupData?.title?.records > allData?.length) {
        const totalRecords =
          panLookupData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
        const newAccounts = panLookupData?.beneficiary_accounts ?? [];
        const currentLength =
          allData?.length ?? GlobalConfiguration.lengthCheckZero;
        const willHaveAll = currentLength + newAccounts.length >= totalRecords;

        setAllData((prevAllData) => {
          const merged = [...prevAllData, ...newAccounts];
          syncLookupCache(payload.panNumber, merged);
          return merged;
        });

        if (
          !willHaveAll &&
          (services?.includes("RUAccount") || services?.includes("Admin"))
        ) {
          const nextPage = page + GlobalConfiguration.lengthCheckOne;
          dispatchLookupIfNeeded(payload.panNumber, nextPage);
          setPage((prevPage) => prevPage + GlobalConfiguration.lengthCheckOne);
        } else if (!willHaveAll) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "RUAccount" },
          });
        }

        if (!willHaveAll) {
          setTest(false);
        } else {
          setTest(true);
        }
      }
      allData?.forEach((val) => {
        if (val?.id === id) {
          setPayload({
            ...payload,
            // gstin:
            //   gstStoredData != null ? gstStoredData : val?.gstin_detail || "",
          });
        }
      });
    }

    const allDataLoaded =
      allData &&
      !panLookupLoading &&
      allData?.length === panLookupData?.title?.records;

    if (allDataLoaded) {
      const hasId = allData.some((val) => val?.id === id);
      setAssociatedPan(hasId);
    } else if (!panLookupLoading && panLookupError && !allData) {
      BenEnableNextButton(false);
      setAssociatedPan(false);
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
    }
  }, [
    panLookupData,
    id,
    panLookupError,
    allData,
    panLookupLoading,
    verifiedPan,
    payload.panNumber,
    haveLinkNew,
    viewAccountDetailData,
  ]);

  useEffect(() => {
    const pan = payload.panNumber;
    const originalPan = reimbursementAcccount?.pan_no;
    const isFullPan = pan?.length === GlobalConfiguration.panLength;

    if (!isFullPan) {
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
      return;
    }

    if (verifiedPan !== true) {
      return;
    }

    if (panLookupLoading) {
      return;
    }

    const lookupAccounts = getLookupAccountsForCurrentPan();
    if (!lookupAccounts.length) {
      return;
    }

    syncLookupCache(pan, lookupAccounts);

    const isPanChangedFromOriginal = pan !== originalPan;

    let bankLinkedToThisPan = lookupAccounts?.find((val) => {
      return (
        isPanChangedFromOriginal &&
        currentBankAccNo &&
        val?.bank_acc_no === currentBankAccNo
      );
    });
    setIsBankLinkedToThisPan(bankLinkedToThisPan);

    const isLinkedOnAnotherAccount =
      isPanChangedFromOriginal &&
      lookupAccounts.some(
        (val) => val?.bank_acc_no === currentBankAccNo && val?.id !== id,
      );

    if (isBankLinkedToThisPan) {
      setAlreadyLinked(true);
      setIsLinkedAccount(false);
      BenEnableNextButton(true);
      setCurrentAssociate(
        // isBankLinkedToThisPan?.type_of_account === "field_force"
        //   ? "Field force account"
        //   :
        isBankLinkedToThisPan?.type_of_account === "reimbursement"
          ? "Reimbursement account"
          : "Beneficiary account",
      );
      setAccActiveInactiveState(
        ["rejected", "blocked", "archived"].includes(
          isBankLinkedToThisPan?.approval_status,
        )
          ? "inactive"
          : "active",
      );
    } else if (isLinkedOnAnotherAccount) {
      setAlreadyLinked(false);
      setIsLinkedAccount(true);
      BenEnableNextButton(true);
    } else {
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
    }
  }, [
    allData,
    panLookupData,
    panLookupLoading,
    verifiedPan,
    payload.panNumber,
    currentBankAccNo,
    reimbursementAcccount?.pan_no,
    id,
  ]);

  const handleNext = () => {};

  const handleBack = () => {
    if (nextButtonEnabled && !openPopEditCheck) {
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
      );
    } else if (openPopEditCheck) {
      setOpenPopEdit(true);
    } else {
      setOpenPopEdit(true);
    }
  };

  useEffect(() => {
    const fetchPANData = async () => {
      let response = await dispatch(viewAccountDetailR({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    sessionStorage.setItem("Pan Gst Verification", JSON.stringify(updatedGst));
  }, [updatedGst]);

  const initializedRef = useRef(false);

  useEffect(() => {
    if (
      initializedRef.current ||
      viewAccountDetailLoading ||
      !viewAccountDetailData?.status
    ) {
      return;
    }
    initializedRef.current = true;
    setIsFocus(true);

    const reimbursementAccount =
      viewAccountDetailData?.reimbursement_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    setUpdatedGst({
      id: reimbursementAccount?.id,
      panNo: reimbursementAccount?.pan_no,
      gstNo: reimbursementAccount?.gstin_detail,
    });
    setPayload({
      ...payload,
      panNumber: reimbursementAccount?.pan_no,
      gstin: reimbursementAccount?.gstin_detail,
      legalName: reimbursementAccount?.pan_legal_name || payload?.legalName,
    });

    if (services?.includes("RUAccount") || services?.includes("Admin")) {
      pendingVerifyPanRef.current = reimbursementAccount?.pan_no || null;
      dispatch(
        verifyPAN({
          pan_number: reimbursementAccount?.pan_no,
          navigate: navigate,
        }),
      );
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "RUAccount" },
      });
    }
  }, [
    viewAccountDetailData,
    viewAccountDetailLoading,
    services,
    dispatch,
    navigate,
  ]);

  const isPanLinkBlocked = (isLinkedAccount || alreadyLinked) && verifiedPan;
  const isFullPanEntered =
    payload.panNumber?.length === GlobalConfiguration.panLength;
  const lookupRecordCount =
    panLookupData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
  const isLookupForCurrentPan = lastLookupRef.current.pan === payload.panNumber;
  const isAwaitingFirstLookupResponse =
    verifiedPan === true &&
    isLookupForCurrentPan &&
    !panLookupLoading &&
    panLookupData == null &&
    !panLookupError;
  const isLookupPaginationPending =
    verifiedPan === true &&
    isLookupForCurrentPan &&
    !panLookupError &&
    lookupRecordCount >
      (allData?.length ?? GlobalConfiguration.lengthCheckZero);
  const isAssociatedLookupPending =
    isFullPanEntered &&
    (panVerificationLoading ||
      panLookupLoading ||
      isAwaitingFirstLookupResponse ||
      isLookupPaginationPending);
  const shouldNextBtnBeEnabled =
    isAssociatedLookupPending || panVerificationLoading || isPanLinkBlocked
      ? false
      : !nextButtonEnabled;
  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "PAN details",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: !cancelBut && "var(--text-disabled)",
      nextIsEnabled:
        verifiedPan === true && panLookupError === true
          ? shouldNextBtnBeEnabled && !updateActive
          : handleUpdateNext && shouldNextBtnBeEnabled && !updateActive,
      nextHoverOption: "black",
      nextIsLoading: cancelBut ? true : false,
      nextLoaderNeeded: true,
    },
  ];

  const handleUpdateAccount = () => {
    if (updateActive || isPanLinkBlocked || isAssociatedLookupPending) return;
    setUpdateActive(true);
    setCanclebtn(true);
    const reimbursementAccount =
      viewAccountDetailData?.reimbursement_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    const linkedUserId =
      reimbursementAccount?.reimbursment_user_id ||
      reimbursementAccount?.linked_user_id ||
      null;
    const resolvedName =
      payload?.legalName ||
      reimbursementAccount?.name ||
      reimbursementAccount?.pan_legal_name ||
      "";
    setTimeout(() => {
      dispatch(
        editReimbursementAccount({
          id: id,
          pan: payload.panNumber,
          name: resolvedName,
          gstin: payload?.gstin,
          linked_user_id: linkedUserId,
          navigate,
        }),
      );
    }, IntervalConfiguration.intervalMedium);
    setAccountType({ type: "", id: "" });
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
  };

  useEffect(() => {
    if (reimbursementAccountEditData?.status === true) {
      const previousData =
        viewAccountDetailData?.reimbursement_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      const updatedFields = [];
      if (previousData?.pan_no !== payload.panNumber) {
        updatedFields.push("pan_no");
      }
      if ((previousData?.gstin_detail || "") !== (payload.gstin || "")) {
        updatedFields.push("gstin_detail");
      }
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/pan_edit_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > GlobalConfiguration.lengthCheckZero
                ? updatedFields
                : ["pan_no"],
          },
          replace: true,
        },
      );
      localStorage.setItem("haveAssociated", JSON.stringify(panLookupError));
      dispatch(resetEditReimbursementAccount());
    }
    if (reimbursementAccountEditError) {
      setUpdateActive(false);
    }
  }, [reimbursementAccountEditData, reimbursementAccountEditError]);

  useEffect(() => {
    panLookupData?.beneficiary_accounts?.forEach((val) => {
      if (val?.id === id) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [panLookupData?.beneficiary_accounts]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("RUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (inputPan?.length < GlobalConfiguration.panLength) {
      setOpenPopEditCheck(true);
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
      setAllData([]);
      setPage(1);
      cachedLookupPanRef.current = null;
      cachedLookupAccountsRef.current = [];
    }
    if (panRegex.test(inputPan)) {
      setOpenPopEditCheck(true);
    }
    if (
      viewAccountDetailData?.reimbursement_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pan_no === inputPan
    ) {
      setOpenPopEditCheck(false);
    }

    if (!specialRegex.test(inputPan)) {
      return;
    }

    if (inputPan?.length > GlobalConfiguration.panLength) {
      return;
    }
    if (
      !panRegex.test(inputPan) &&
      inputPan?.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);

      dispatch(resetPanLookup());
      setPayload({
        ...payload,
        gstin: "",
      });
    } else if (inputPan?.length === GlobalConfiguration.panLength) {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }
      if (panRegex.test(inputPan)) {
        dispatch(resetPANVerification());
        dispatch(resetPanLookup());
        cachedLookupPanRef.current = null;
        cachedLookupAccountsRef.current = [];
        lastLookupRef.current = { pan: null, page: null };
        setVerifiedPan(null);
        verifyDebounceRef.current = setTimeout(() => {
          verifyDebounceRef.current = null;
          abortControllerRef.current?.abort();
          abortControllerRef.current = new AbortController();
          pendingVerifyPanRef.current = inputPan;
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;

          if (services?.includes("RUAccount") || services?.includes("Admin")) {
            dispatch(
              verifyPAN({
                pan_number: inputPan,
                navigate: navigate,
                signal: abortControllerRef.current.signal,
                showToast: false,
              }),
            );
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "RUAccount" },
            });
          }
        }, VERIFY_DEBOUNCE_MS);
      }
      setAllData([]);
      setPage(1);
    } else {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }
      retryCountRef.current = GlobalConfiguration.lengthCheckZero;
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
      setAccountType({ type: "", id: "" });

      setShowAccInfo(false);
      sessionStorage.removeItem("PAN GST Edit NewValue");
      lastLookupRef.current = { pan: null, page: null };
    }

    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: "",
    });
    setAccountType({ type: "", id: "" });
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
    setDisableCreateNext(false);
    setIsActive(false);
    setHideCreate(false);
    setAlreadyLinked(false);
    setIsLinkedAccount(false);
    setIsBankLinkedToThisPan(null);
    setHandleUpdateNext(false);
  };

  const handleConfirm = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };

  const handleEnterKeyPress = useCallback(
    (e) => {
      const canUpdate =
        (isLinkedAccount || alreadyLinked) && verifiedPan
          ? nextButtonEnabled
          : !nextButtonEnabled && !updateActive;

      if (e.key === "Enter" && canUpdate) {
        handleUpdateAccount();
      }
    },
    [
      isLinkedAccount,
      alreadyLinked,
      verifiedPan,
      nextButtonEnabled,
      updateActive,
      handleUpdateAccount,
    ],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  return (
    <div className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-hidden h-screen">
      <div className="min-h-navbar-breadcrumb-height hidden Qsmd:block"></div>
      <div
        className={`edit_pan_con_main ${!panLookupLoading && verifiedPan === true ? "" : " h-full-height"} lg:h-full-height bg-primary-bg overflow-y-auto`}
        style={{
          overflowY: openPopEdit || showRejectTnxPopup ? "hidden" : "",
          height: openPopEdit || showRejectTnxPopup ? "var(--full-height)" : "",
        }}
      >
        {openPopEdit && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Leaving this page will not update the changes made."
              btnOneText="Stay"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => setOpenPopEdit(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleConfirm}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {/* <div className=" h-navbar-height block Qsmd:hidden"></div> */}
        <div className="bg-primary-nav  block Qmd:hidden w-full">
          <TopNavComponent
            isFormattingNotRequired
            topNavSubText="PAN details"
            topNavHeader={"Reimbursement Account"}
            topNavCtaBtn1Props={{
              btnText: "Update",
              btnType: "button",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              disabledBgColor: "var(--text-disabled)",
              disabledTextColor: "var(--text-primary)",
              isDisabled: !(
                shouldNextBtnBeEnabled &&
                !updateActive &&
                !panLookupLoading
              ),

              handleFunction:
                shouldNextBtnBeEnabled && !updateActive && !panLookupLoading
                  ? handleUpdateAccount
                  : () => {},
              inActiveVariantNeeded: true,
            }}
          />
        </div>
        <div className="main_edit_stepper_div  z-z-index-toast hidden Qsmd:block">
          <div className="bene_crt_reminder_header flex justify-center items-end w-screen Qmd:relative fixed bottom-bottom-base left-left-base z-z-index-loader min-h-stepper-height">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
        </div>
        <div className="edit_pan_details_all !pt-padding-base Qsmd:!pt-padding-lg mt-margin-base Qlg:overflow-hidden  lg:h-full-height overflow-y-auto hidden w-full">
          <ReimbursementPanDetails
            showAccInfo={showAccInfo}
            allData={allData}
            setShowAccInfo={setShowAccInfo}
            associatedPan={associatedPan}
            test={test}
            gstin={payload?.gstin}
            panNumber={payload.panNumber}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={panVerificationData?.pan_details}
            beneLookData={panLookupData}
            beneLookLoading={panLookupLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={panVerificationLoading}
            isAchived={isAchived}
            setIsArchived={setIsArchived}
            setIsApproved={setIsApproved}
            isApproved={isApproved}
            handleNext={handleNext}
            accountType={accountType}
            setAccountType={setAccountType}
            isDennied={isDennied}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            isPending={isPending}
            nextButtonEnabled={nextButtonEnabled}
            shutViewAll={shutViewAll}
            setShutViewAll={setShutViewAll}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            panLatestData={payload.panNumber}
            isFocus={isFocus}
            setIsFocus={setIsFocus}
            type={"editFlow"}
            showAction={showAction}
            setShowAction={setShowAction}
            previousId={id}
            isActive={isActive}
            setIsActive={setIsActive}
            beneLookError={panLookupError}
            setHideCreate={setHideCreate}
            hideCreate={hideCreate}
            previousBankNo={previousBankNo}
            setPreviousBankNo={setPreviousBankNo}
            isLinkedAccount={isLinkedAccount}
            setIsLinkedAccount={setIsLinkedAccount}
            alreadyLinked={alreadyLinked}
            setAlreadyLinked={setAlreadyLinked}
            haveLinkNew={haveLinkNew}
            setPayload={setPayload}
            payload={payload}
            setGSTPanExist={setGSTPanExist}
            GSTPanExist={GSTPanExist}
            showRejectTnxPopup={showRejectTnxPopup}
            setRejectTxnPopup={setRejectTxnPopup}
            accActiveInactiveState={accActiveInactiveState}
            setAccActiveInactiveState={setAccActiveInactiveState}
            currentAssociate={currentAssociate}
            setCurrentAssociate={setCurrentAssociate}
            id={id}
            isBankLinkedToThisPan={isBankLinkedToThisPan}
            shouldNextBtnBeEnabled={shouldNextBtnBeEnabled}
            updateActive={updateActive}
            setHandleUpdateNext={setHandleUpdateNext}
            handleUpdateNext={handleUpdateNext}
          />
        </div>
      </div>
    </div>
  );
};

export default ReimbursementEditPan;
